import { render } from "./COIActionBarDownloadInvoice.vue?vue&type=template&id=7527a2e8"
import script from "./COIActionBarDownloadInvoice.vue?vue&type=script&lang=js"
export * from "./COIActionBarDownloadInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__